import React from 'react';
import { useNavigate } from 'react-router-dom';

const BuiltFor = () => {
  const navigate = useNavigate();
  const targets = [
    { number: '01', title: 'Multifamily property managers (2,500+ units)' },
    { number: '02', title: 'REITs and Owner Operators' },
    { number: '03', title: 'Affordable Housing Managers' },
    { number: '04', title: 'Student Housing & Built-to-rent Portfolios' }
  ];

  return (
    <section className="built-for-wrapper">
      {/* Vertical Dividers */}
      <div className="built-for-divider built-for-divider-1"></div>
      <div className="built-for-divider built-for-divider-2"></div>
      <div className="built-for-divider built-for-divider-3"></div>
      <div className="built-for-divider built-for-divider-4"></div>
      <div className="built-for-divider built-for-divider-5"></div>

      {/* Content Column */}
      <div className="built-for-content">
        <div className="built-for-title-section">
          <h2 className="built-for-title">CaptiveWorks is Built for</h2>
        </div>

        <div className="built-for-grid">
          {targets.map((target, index) => (
            <div 
              className={`built-for-card ${index === 2 || index === 3 ? 'no-right-border' : ''}`} 
              key={index}
            >
              <div className="built-for-card-content">
                <h3 className="built-for-card-title">{target.title}</h3>
              </div>
              <div className="built-for-card-number">{target.number}</div>
            </div>
          ))}
        </div>

        <button 
          className="btn-schedule-built-for"
          onClick={() => navigate('/schedule-call')}
        >
          <span>Schedule a Call</span>
          <span className="btn-schedule-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M10 7L15 12L10 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        </button>
      </div>

      {/* Example Card */}
      <div className="built-for-example-card">
        <div className="example-label">Example</div>
        <p className="example-text">
          A 10,000-unit portfolio generating $1.5M in annual premium can expect to receive an additional
        </p>
        <div className="example-value">$500,000+</div>
        <p className="example-text">
          per year in underwriting profit — while improving compliance rates and claims experience.
        </p>
      </div>

      {/* Corner Indicators */}
      <div className="built-for-corner built-for-corner-1"></div>
      <div className="built-for-corner built-for-corner-2"></div>
    </section>
  );
};

export default BuiltFor;
